import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./blc_footerone.css";
import Button from "react-bootstrap/Button";
import FormControl from "react-bootstrap/FormControl";
import InputGroup from "react-bootstrap/InputGroup";
import { useFeedBack } from "../../Blc_Business/BlcHomeLandingPage/HomeWindowTwo";
import FeedBackModal from "./FeedBackModal";
import Form from "react-bootstrap/Form";
import { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FooterNotificationOne, FooterNotificationTwo } from "./Blc_FooterNotification";

const Blc_footerOne = (props) => {
  const [validated, setValidated] = useState(false);
  const [subscribe, setSubscribe] = useState("");
  const [subscribeNoti, setSubscribeNoti] = useState(false);
  const [subscribeNotiErr, setSubscribeNotErr] = useState(false);

  useEffect(()=>{

  },[subscribeNoti,subscribeNotiErr])
  // console.log(useFeedBack());
  const cusFeed = useFeedBack();
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
    }
    if (form.checkValidity() === true) {
      let subscribeEmail = {
        email: subscribe,
      };
      axios
        .post(
          "https://blc.brac.net/subscribe",
          subscribeEmail
        )
        .then((response) => {
         
         
           setSubscribeNoti(true);
          
        })
        .catch((err) => {
         
         setSubscribeNotErr(true);
          
        });

      setSubscribe("");
      setValidated(false);
    }
  };

  const subscribeHandler = (event) => {
   setSubscribeNotErr(false);
   setSubscribeNoti(false);
    setSubscribe(event.target.value);
  };

  return (
    <>
     {subscribeNoti && FooterNotificationOne() || subscribeNoti && FooterNotificationTwo()}
      <Row className="fRowtwo">
        <Col>
          <h3 className="text-center">Save The Money!</h3>
          <p className="text-center">
            sign up and we'll send best deals to you.
          </p>
        </Col>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Col>
            <InputGroup className="mb-3">
              <FormControl
                required
                value={subscribe}
                placeholder="Your Email"
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                onChange={subscribeHandler}
              />
              <Button
                type="submit"
                className="button-color"
                id="button-addon2"
                style={{ borderRadius: "2px" }}
              >
                Subscribe
              </Button>
              <Form.Control.Feedback type="invalid">
                Please, Enter Your Email
              </Form.Control.Feedback>
            </InputGroup>
          </Col>
        </Form>
        <Col className="py-4 d-flex justify-content-center">
          <Button className="feedback-color" onClick={() => cusFeed[1](true)}>
            Give Us Your Feedback
          </Button>
        </Col>
      </Row>
      <FeedBackModal show={cusFeed[0]} onHide={() => cusFeed[1](false)} />
    </>
  );
};

export default Blc_footerOne;
